import { SidebarHeader, SidebarLayout } from '@scale/scaleui';
import React, { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useToggle } from 'react-use-v13';
import ScaleHead from 'design-system/Head';
import { GrowthCenterDashboardHeader } from './GrowthCenterDashboardHeader';
import { GrowthCenterNavigation } from 'react-scale/components/GrowthCenter/GrowthCenterNavigation';
import { GrowthCenterContent } from 'react-scale/components/GrowthCenter/GrowthCenterContent';
import { IUserJson } from '@scale/shared/types/user';
import {
  MagicSearchProvider,
  recentSearchesPlugin,
  reactQueryPlugin,
} from 'react-scale/corp/views/CorpProjectGroupManager/modules/MagicSearch';
import { Routes } from 'react-scale/components/GrowthCenter/urls';
import { queryClient, queryFactory } from './OnboardingControlPanel/api';
import { GenAIOpsHubPaths } from 'react-scale/corp/views/CorpProjectGroupManager/constants';
import { queryFactory as opsHubQueryFactory } from 'react-scale/corp/views/CorpProjectGroupManager/communication/apiClient';

const GrowthCenterPage: React.FC<{ user: IUserJson }> = ({ user }) => {
  const magicSearchPlugins = useMemo(
    () => [
      reactQueryPlugin({
        headerProps: {
          children: 'Lookup',
        },
        basePath: GenAIOpsHubPaths.CorpLookup,
        hint: 'corp lookup id',
        queryClient,
        queryFactoryFunction: opsHubQueryFactory.lookup.search,
      }),
      recentSearchesPlugin({
        localStorageKey: 'growth-center-recent-searches',
      }),
      reactQueryPlugin({
        headerProps: {
          children: 'Flows',
        },
        basePath: Routes.OnboardingControlPanel,
        hint: 'flow name or id, user name or id',
        queryClient,
        queryFactoryFunction: queryFactory.flows.search,
      }),
    ],
    [],
  );

  const [sidebarOpen, toggleSidebarOpen] = useToggle(false);
  return (
    <MagicSearchProvider plugins={magicSearchPlugins}>
      <BrowserRouter basename="/corp">
        <div className="scaleui scale-theme scale-tailwind bg-neutral-50">
          <ScaleHead title="Growth Center" />
          <SidebarLayout
            asideClassName="z-20 pt-3"
            sidebarOpen={sidebarOpen}
            sidebar={
              <div className="flex flex-col flex-grow mt-4 overflow-y-auto bg-neutral-0">
                <SidebarHeader toggleSidebar={toggleSidebarOpen} sidebarOpen={sidebarOpen} />
                <div className="flex flex-col justify-between h-full">
                  <GrowthCenterNavigation sidebarOpen={sidebarOpen} />
                </div>
              </div>
            }
            headerClassName="z-20"
            header={<GrowthCenterDashboardHeader />}
            content={<GrowthCenterContent user={user} />}
          />
        </div>
      </BrowserRouter>
    </MagicSearchProvider>
  );
};

export default GrowthCenterPage;
